module.exports = __webpack_public_path__ + "img/site_type_img_17.8389dcbd.png";